import { useEffect } from "react";
import { Outlet } from "react-router";
import "../globals.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import { PWAProvider } from "@/components/PWAProvider";
import { FeedbackButton } from "@/components/feedback";
import { AuthProvider } from "@/lib/auth-context";
import { BrandingProvider, useBranding } from "@/lib/branding-context";

function DocumentTitle() {
  const { branding } = useBranding();
  useEffect(() => {
    const base = branding.appName || "One Voice";
    document.title = base;
    const apple = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (apple) apple.setAttribute("content", base);
  }, [branding.appName]);
  return null;
}

export function RootLayout() {
  return (
    <div className="min-h-screen font-sans antialiased">
      <AuthProvider>
        <BrandingProvider>
          <DocumentTitle />
          <PWAProvider>
            <div className="relative flex min-h-screen flex-col">
              <Outlet />
            </div>
            <FeedbackButton />
          </PWAProvider>
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}
